import supabaseClient from '@/api/supabaseClient.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

export type RequestIntroCallParams = {
  carer_id: string;
  preferred_date?: string;
  preferred_time_from?: string;
  preferred_time_to?: string;
  message?: string;
  meeting_link?: string;
};

const useRequestIntroCall = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (params: RequestIntroCallParams) => {
    const { data, error } = await supabaseClient.functions.invoke('request_intro_call', {
      method: 'POST',
      body: params,
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: (_data, variables) => {
      // Invalidate the carer details query to refetch with updated intro call status
      queryClient.invalidateQueries({ queryKey: ['carer', variables.carer_id] });
    },
  });
};

export default useRequestIntroCall;
